import React from 'react';
import './SuggestionItem.css';

/**
 * Props for SuggestionItem component
 */
interface SuggestionItemProps {
  suggestion: string;
  isSelected: boolean;
  index: number;
  onClick: () => void;
}

/**
 * Individual suggestion item in the dropdown list.
 * Handles display and selection state of a single suggestion.
 *
 * @param suggestion - Text to display
 * @param index - Position in list
 * @param isSelected - Whether this item is currently selected
 * @param onClick - Click handler for selection
 */
const SuggestionItem: React.FC<SuggestionItemProps> = ({
  suggestion,
  index,
  isSelected,
  onClick
}) => (
  <li
    key={index}
    role="option"
    onClick={onClick}
    className={`suggestion-item ${isSelected ? 'selected' : ''}`}
    aria-selected={isSelected}
  >
    {suggestion}
  </li>
);

export default SuggestionItem;